






























































































































import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { FormState } from '@/components/prine/enums/FormState';
import DetailedConfirmModal from '@/components/prine/DetailedConfirmModal.vue';

import type { User } from '@/models/user';
import { pmSubPhaseWebservice } from '@/webservices/pmsubphase';
import type { PMSubPhase } from '@/models/pmsubphase';
import type { PMPhase } from '@/models/pmphase';
import PrineButton from '@/components/prine/PrineButton.vue';
import type { CompanySetting } from '@/models/companySetting';
import { hasPermission } from '@/helpers/auth/permissionHelpers';
import { PERMISSIONS } from '@/helpers/auth/permissions';

@Component({
    name: 'StoreUpdatePMSubPhase',
    computed: {
        PERMISSIONS() {
            return PERMISSIONS;
        },
    },
    methods: { hasPermission },
    components: {
        DetailedConfirmModal,
        PrineButton,
    },
})
export default class StoreUpdatePMSubPhase extends Vue {
    public FormState = FormState;

    // Data
    protected disabled: boolean = false;
    protected loaded: boolean = false;
    protected errorMsg: string = '';
    protected isConfirmModalActive: boolean = false;
    protected state: FormState = FormState.New;

    protected pmsubphase: PMSubPhase = {
        phase: {} as PMPhase,
    } as PMSubPhase;

    protected loading = {
        data: false,
        color: '#fdc05d',
        size: '40px',
    };

    protected affectedData: Map<string, number> = new Map();

    @Getter('account/userInfo') private userInfo: User;
    @Getter('account/companySetting') private companySetting: CompanySetting;
    @Getter('utils/currentLocale') private currentLocale: string;

    // Mounted is called initially
    private mounted() {
        if (this.$route.query.subPhaseId) {
            this.load(Number(this.$route.query.subPhaseId));
            this.state = FormState.Update;
        }

        // If there is a pmPhaseId passed store it in the model
        if (this.$route.query.phaseId) {
            this.pmsubphase.phase.id = Number(this.$route.query.phaseId);
        }
        this.loaded = true;
    }

    private load(phaseId: number) {
        this.loading.data = true;
        pmSubPhaseWebservice.getById(phaseId.toString()).then((response) => {
            this.pmsubphase = response.data;
            this.loading.data = false;

            this.affectedData.set(this.$tc('keywords.lesson', 2).toString(), this.pmsubphase.lessons_count);
        });
    }

    private save() {
        this.disabled = true;
        if (!this.validate()) {
            this.disabled = false;
            return 0;
        }

        if (this.state === FormState.New) {
            pmSubPhaseWebservice
                .store(this.pmsubphase)
                .then((response) => {
                    this.$buefy.toast.open({
                        duration: 3000,
                        message: this.$t('toastMessages.store.generic', {
                            x:
                                this.currentLocale === 'en'
                                    ? this.companySetting.pm_en_sub_process_title
                                    : this.companySetting.pm_de_sub_process_title,
                        }).toString(),
                        type: 'is-success',
                    });
                    this.$router.push({
                        name: 'GroupedPMLessonsList',
                        query: {
                            phaseId: this.pmsubphase.phase.id.toString(),
                        },
                    });
                    this.$emit('syncKnowledge');
                })
                .catch((error) => {
                    this.disabled = false;
                    console.log(error);
                });
        } else if (this.state === FormState.Update) {
            pmSubPhaseWebservice
                .update(this.pmsubphase)
                .then((response) => {
                    this.$buefy.toast.open({
                        duration: 3000,
                        message: this.$t('toastMessages.update.generic', {
                            x:
                                this.currentLocale === 'en'
                                    ? this.companySetting.pm_en_sub_process_title
                                    : this.companySetting.pm_de_sub_process_title,
                        }).toString(),
                        type: 'is-success',
                    });
                    this.$router.push({
                        name: 'GroupedPMLessonsList',
                        query: {
                            phaseId: this.pmsubphase.phase.id.toString(),
                        },
                    });
                    this.$emit('syncKnowledge');
                    this.disabled = false;
                })
                .catch((error) => {
                    this.disabled = false;
                    console.log(error);
                });
        }
    }

    private toggleConfirmModal(answer = false) {
        this.isConfirmModalActive = !this.isConfirmModalActive;
        if (answer) {
            this.remove();
        }
    }

    private remove() {
        pmSubPhaseWebservice
            .remove(this.pmsubphase)
            .then((response) => {
                this.$buefy.toast.open({
                    duration: 3000,
                    message: this.$t('toastMessages.delete.generic', {
                        x:
                            this.currentLocale === 'en'
                                ? this.companySetting.pm_en_sub_process_title
                                : this.companySetting.pm_de_sub_process_title,
                    }).toString(),
                    type: 'is-success',
                });
                this.$router.push({
                    name: 'GroupedPMLessonsList',
                    query: {
                        phaseId: this.pmsubphase.phase.id.toString(),
                    },
                });
                this.$emit('syncKnowledge');
            })
            .catch((error) => {
                console.log(error);
            });
    }

    private validate() {
        if (!this.pmsubphase.title || this.pmsubphase.title === '') {
            this.errorMsg = 'title';
            return 0;
        } else if (this.pmsubphase.order === undefined || isNaN(Number(this.pmsubphase.order))) {
            this.errorMsg = 'orderNotNumber';
            return 0;
        } else {
            return true;
        }
    }
}
